<div class="top-margin">
  <div class="corner-stone"></div>
  <div class="top-nav-bar">

    <div class="dropmenu dropmenumain drop-project" kind="project" style="margin-left: 0;"></div>

    <div class="dropmenu dropmenumain drop-window" kind="scenario" style="margin-left: 8px;"></div>

    <div class="dropmenu dropmenumain drop-window" kind="tools" style="margin-left: 8px;"></div>

    <div class="dropmenu dropmenumain drop-window" kind="window" style="margin-left: 8px;"></div>

    <div class="dropmenu dropmenumain drop-help" kind="help" style="margin-left: 8px;"></div>

    <div class="sim-button" style="margin-left: 8px; display: inline-block;"></div>

    <div class="quick-search-input" style="margin-left: 8px; display: inline-block;"></div>

    <div class="simple-navbar-button" style="margin-right: 4px; float: right;" (click)="logout()"><span>LOGOUT</span></div>

    <div class="dropmenu drop-user-details" style="float: right; margin-right: 24px;"></div>

    <div class="dropmenu dropmenumain drop-settings" kind="settings" style="float: right; margin-right: 24px;"></div>


  </div>

</div>

<div class="left-margin">

  <div class="project-button"></div>

</div>

<div class="right-margin">

  <div class="properties-button"></div>

</div>

<div id="dock_div" >

  <div id="my_dock_manager" class="my-dock-manager" style="position: relative;">
  </div>

  <div id="solution_window"
       class="solution-window window-panel"
       hidden>
    <div id="projecttree" style="overflow: hidden;"></div>
  </div>

  <div id="properties_window"
       data-panel-caption="Properties"
       class="properties-window  window-panel"
       hidden>
    <div id="propertiestable"></div>
  </div>

  <div id="problems_window" data-panel-caption="Problems" class="problems-window  window-panel" hidden>
    <p>PROBLEMS</p>
  </div>

  <div id="output_window" data-panel-caption="Output" class="output-window editor-host  window-panel" hidden>
    <p>OUTPUT</p>
  </div>

  <div id="outline_window" data-panel-caption="Outline" class="outline-window  window-panel" hidden>
    <p>OUTLINE</p>
  </div>

  <div id="toolbox_window" data-panel-caption="Toolbox" class="toolbox-window  window-panel" hidden>
    <p>TOOLBOX</p>
  </div>

</div>

<div class="bottom-margin">

  <div class="dropmenu online-details"></div>

  <div class="dropmenu task-progress"></div>

</div>

<!-- new batch measure/summary -->
<app-modal-dialog id="new-batch-summary" kind="batchsummary"></app-modal-dialog>

<!-- new batch regression -->
<app-modal-dialog id="new-regression-modal" kind="batchregression" modalsize="modal-lg"></app-modal-dialog>

<!-- import corridor batch -->
<app-modal-dialog id="new-corridorbatch-modal" kind="corridorbatch" modalsize="modal-lg"></app-modal-dialog>

<!-- sim results / details dialog -->
<app-modal-dialog id="blob-history-modal" kind="blob-history" modalsize="modal-lg"></app-modal-dialog>

<!-- sim results / details dialog -->
<app-modal-dialog id="sim-details-modal" kind="sim-details" modalsize="modal-lg"></app-modal-dialog>

<!-- new project dialog -->
<app-modal-dialog id="new-project-modal" kind="new-project"></app-modal-dialog>

<!-- open project dialog -->
<app-modal-dialog id="open-project-modal" kind="open-project"></app-modal-dialog>

<!-- clone project dialog -->
<app-modal-dialog id="clone-project-modal" kind="clone-project"></app-modal-dialog>

<!-- new simulation dialog -->
<app-modal-dialog id="new-simulation-modal" kind="new-simulation"></app-modal-dialog>

<!-- new loco dialog -->
<app-modal-dialog id="new-loco-modal" kind="new-loco-model"></app-modal-dialog>

<!-- new operational measure dialog -->
<app-modal-dialog id="new-opmeasure-modal" kind="new-opmeasure-model"></app-modal-dialog>

<!-- rename element dialog -->
<app-modal-dialog id="rename-element-modal" kind="rename-element"></app-modal-dialog>

<!-- save as blob element dialog -->
<app-modal-dialog id="saveblobas-element-modal" kind="saveblobas-element"></app-modal-dialog>

<!-- new input dimension dialog -->
<app-modal-dialog id="new-dimension-modal" kind="new-dimension"></app-modal-dialog>

<!-- new file (empty) dialog -->
<app-modal-dialog id="new-empty-modal" kind="new-empty-blob"></app-modal-dialog>

<!-- add blob from upload dialog -->
<app-modal-dialog id="add-upload-modal" kind="add-upload-blob"></app-modal-dialog>

<!-- add blob dialog -->
<app-modal-dialog id="add-blob-modal" kind="add-blob"></app-modal-dialog>

<!-- new folder dialog -->
<app-modal-dialog id="new-folder-modal" kind="new-folder"></app-modal-dialog>

<!-- error message dialog -->
<app-modal-dialog id="error-msg-modal" kind="error-msg"></app-modal-dialog>
